/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * OpenAPI spec version: Latest
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { AlertActiveListResponse } from '../models';
import { AlertDismissCommand } from '../models';
import { AlertDismissResponse } from '../models';
import { AlertListResponse } from '../models';
/**
 * AlertApi - axios parameter creator
 * @export
 */
export const AlertApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns a list of active alerts for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAlertActiveListGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Alert/ActiveList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Dismisses an alert for the current user profile.
         * @param {AlertDismissCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAlertDismissPost: async (body?: AlertDismissCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Alert/Dismiss`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of all alerts.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAlertListGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Alert/List`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AlertApi - functional programming interface
 * @export
 */
export const AlertApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns a list of active alerts for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAlertActiveListGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlertActiveListResponse>> {
            const localVarAxiosArgs = await AlertApiAxiosParamCreator(configuration).apiAlertActiveListGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Dismisses an alert for the current user profile.
         * @param {AlertDismissCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAlertDismissPost(body?: AlertDismissCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlertDismissResponse>> {
            const localVarAxiosArgs = await AlertApiAxiosParamCreator(configuration).apiAlertDismissPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns a list of all alerts.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAlertListGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlertListResponse>> {
            const localVarAxiosArgs = await AlertApiAxiosParamCreator(configuration).apiAlertListGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AlertApi - factory interface
 * @export
 */
export const AlertApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Returns a list of active alerts for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAlertActiveListGet(options?: any): AxiosPromise<AlertActiveListResponse> {
            return AlertApiFp(configuration).apiAlertActiveListGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Dismisses an alert for the current user profile.
         * @param {AlertDismissCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAlertDismissPost(body?: AlertDismissCommand, options?: any): AxiosPromise<AlertDismissResponse> {
            return AlertApiFp(configuration).apiAlertDismissPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of all alerts.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAlertListGet(options?: any): AxiosPromise<AlertListResponse> {
            return AlertApiFp(configuration).apiAlertListGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AlertApi - object-oriented interface
 * @export
 * @class AlertApi
 * @extends {BaseAPI}
 */
export class AlertApi extends BaseAPI {
    /**
     * 
     * @summary Returns a list of active alerts for the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertApi
     */
    public apiAlertActiveListGet(options?: any) {
        return AlertApiFp(this.configuration).apiAlertActiveListGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Dismisses an alert for the current user profile.
     * @param {AlertDismissCommand} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertApi
     */
    public apiAlertDismissPost(body?: AlertDismissCommand, options?: any) {
        return AlertApiFp(this.configuration).apiAlertDismissPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns a list of all alerts.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertApi
     */
    public apiAlertListGet(options?: any) {
        return AlertApiFp(this.configuration).apiAlertListGet(options).then((request) => request(this.axios, this.basePath));
    }
}
